import { createReducer, on } from '@ngrx/store';
import * as EventsActions from './events.actions';
import { initialEventsState } from './events.state';

export const eventsReducer = createReducer(
  initialEventsState,

  on(EventsActions.loadUpcomingEvents, (state, { page }) => ({
    ...state,
    loading: page === 1,
    loadingMoreUpcomingEvents: page > 1,
  })),

  on(EventsActions.loadMoreUpcomingEvents, (state) => ({
    ...state,
    loadingMoreUpcomingEvents: true,
  })),

  on(EventsActions.loadPastEvents, (state, { page }) => ({
    ...state,
    loading: page === 1,
    loadingMorePastEvents: page > 1,
  })),

  on(EventsActions.loadMorePastEvents, (state) => ({
    ...state,
    loadingMorePastEvents: true,
  })),

  on(EventsActions.loadInPreparationEvents, (state, { page }) => ({
    ...state,
    loading: page === 1 ? true : state.loading,
    loadingMoreInPreparationEvents: page > 1,
  })),

  on(EventsActions.loadMoreInPreparationEvents, (state) => ({
    ...state,
    loadingMoreInPreparationEvents: true,
  })),

  on(EventsActions.loadUpcomingEventsSuccess, (state, { events, total, page, totalPages, limit, append }) => ({
    ...state,
    upcomingEvents: append ? [ ...state.upcomingEvents, ...events ] : events,
    upcomingEventsPagination: {
      currentPage: page,
      totalPages,
      total,
      limit,
    },
    loading: false,
    loadingMoreUpcomingEvents: false,
    error: null,
  })),

  on(EventsActions.loadPastEventsSuccess, (state, { events, total, page, totalPages, limit, append }) => ({
    ...state,
    pastEvents: append ? [ ...state.pastEvents, ...events ] : events,
    pastEventsPagination: {
      currentPage: page,
      totalPages,
      total,
      limit,
    },
    loading: false,
    loadingMorePastEvents: false,
    error: null,
  })),

  on(EventsActions.loadInPreparationEventsSuccess, (state, { events, total, page, totalPages, limit, append }) => ({
    ...state,
    inPreparationEvents: append ? [ ...state.inPreparationEvents, ...events ] : events,
    inPreparationEventsPagination: {
      currentPage: page,
      totalPages,
      total,
      limit,
    },
    loading: false,
    loadingMoreInPreparationEvents: false,
    error: null,
  })),

  on(
    EventsActions.loadUpcomingEventsFailure,
    EventsActions.loadPastEventsFailure,
    EventsActions.loadInPreparationEventsFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      loadingMoreUpcomingEvents: false,
      loadingMoreInPreparationEvents: false,
      loadingMorePastEvents: false,
      error,
    }),
  ),
);
